<template>
  <b-form data-vv-scope="personal">
    <div class="d-flex flex-column" style="gap: 24px;">
      <div class="title">
        <h5>{{ $t("views.seller.my_account.text_1159") }}</h5>
        <p>{{ $t("views.seller.my_account.text_1269") }}</p>
      </div>
      <b-row>
        <b-col cols="12" md="6">
          <BaseInput 
            label-for="name" 
            name="name" 
            v-model="user.name" 
            type="text" 
            maxlength="40" 
            v-validate="'required'"
            :placeholder="$t('views.seller.my_account.text_1160')" 
            :label="$t('views.seller.my_account.text_1569')"
            :isValid="!errors.has('personal.name')" 
            :errorMessage="$t('views.seller.my_account.text_1161')"
            :disabled="$root.modeEdit"
          />
        </b-col>

        <b-col cols="12" md="6">
          <BaseInput 
            label-for="birth_date" 
            name="birth_date"
            v-model="user.birth_date" 
            type="text" 
            v-mask="['##/##/####']"
            v-validate="'required|date_format:dd/MM/yyyy'" 
            :label="$t('views.seller.my_account.text_1272')"
            :placeholder="$t('views.seller.my_account.text_1273')" 
            :isValid="!errors.has('personal.birth_date')"
            :errorMessage="
              errors.has('personal.birth_date') 
              ? errors.first('personal.birth_date').replace('birth_date', $t('views.seller.my_account.text_1272'))
              : ''
            "
            :disabled="$root.modeEdit"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <BaseInput 
            label-for="cpf" 
            name="cpf" 
            v-model="user.cpf_cnpj" 
            type="text" 
            v-validate="'required|cpf_cnpj'"
            v-mask="['###.###.###-##']" 
            :label="$t('views.seller.my_account.text_1575')"
            :placeholder="$t('views.seller.my_account.text_1274')" 
            :isValid="!errors.has('personal.cpf')"
            :errorMessage="$t('views.seller.my_account.text_1162')"
            :disabled="$root.modeEdit"
          />
        </b-col>
        <b-col cols="12" md="6">
          <BaseInput 
            name="rg" 
            v-model="user.rg" 
            label-for="rg" 
            type="text" 
            v-validate="'required'"
            v-mask="['#############']" 
            :placeholder="$t('views.seller.my_account.text_1275')"
            :label="$t('views.seller.my_account.text_1577')" 
            :isValid="!errors.has('personal.rg')"
            :errorMessage="$t('views.seller.my_account.text_1167')"
            :disabled="$root.modeEdit"
          />
        </b-col>
      </b-row>

    </div>

    <div class="divider"></div>
    <div class="d-flex flex-column" style="gap: 24px;">
			<div class="title">
				<h5>{{ $t("views.seller.my_account.text_1270") }}</h5>
				<p>{{ $t("views.seller.my_account.text_1271") }}</p>
			</div>

			<b-row>
				<b-col cols="12" md="6">
					<BaseInput 
            id="zip_code" 
            name="zip_code" 
            v-model="zipCode" 
            v-mask="['#####-###']" 
            type="text"
            v-validate="'required'"
            @input="debounce"
            :placeholder="$t('views.seller.my_account.text_1169')"
						:label="$t('views.seller.my_account.text_1578')"
            :isValid="!errors.has('personal.zip_code')"
            :errorMessage="$t('views.seller.my_account.text_1301')"
            :disabled="$root.modeEdit"
          >
					</BaseInput>
				</b-col>
				<b-col cols="12" md="6">
					<BaseInput 
            id="street" 
            name="street" 
            v-model="address.street" 
            type="text"
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1170')"
						:placeholder="$t('views.seller.my_account.text_1276')" 
            :isValid="!errors.has('personal.street')"
            :errorMessage="$t('views.seller.my_account.text_1302')"
            :disabled="$root.modeEdit"
          >
					</BaseInput>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" md="6">
					<BaseInput 
            id="number" 
            name="number" 
            v-model="address.number" 
            v-mask="['########']" 
            type="text"
            v-validate="'required'"
            :placeholder="$t('views.seller.my_account.text_1579')" 
						:label="$t('views.seller.my_account.text_1171')"
            :isValid="!errors.has('personal.number')"
            :errorMessage="$t('views.seller.my_account.text_1303')"
            :disabled="$root.modeEdit"
          >
					</BaseInput>
				</b-col>
				<b-col cols="12" md="6">
					<BaseInput 
            id="neighborhood" 
            name="neighborhood" 
            v-model="address.neighborhood" 
            type="text"
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1580')"
						:placeholder="$t('views.seller.my_account.text_1172')" 
            :isValid="!errors.has('personal.neighborhood')"
            :errorMessage="$t('views.seller.my_account.text_1304')"
            :disabled="$root.modeEdit"
          >
					</BaseInput>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" md="6">
					<BaseInput 
            id="city" 
            name="city" 
            v-model="address.city" 
            type="text"
            v-validate="'required'"
            :placeholder="$t('views.seller.my_account.text_1582')" 
						:label="$t('views.seller.my_account.text_1581')"
            :isValid="!errors.has('personal.city')"
            :errorMessage="$t('views.seller.my_account.text_1305')"
            :disabled="$root.modeEdit"
          >
					</BaseInput>
				</b-col>
				<b-col cols="12" md="6">
					<BaseInput 
            id="state" 
            name="state" 
            v-model="address.state" 
            type="text"
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1583')"
						:placeholder="$t('views.seller.my_account.text_1584')" 
            :isValid="!errors.has('personal.state')"
            :errorMessage="$t('views.seller.my_account.text_1306')"
            :disabled="$root.modeEdit"
          >
					</BaseInput>
				</b-col>
			</b-row>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile
            name="address_file"
            sizeUnit="mb"
            :label="$t('views.seller.my_account.text_1277')"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1278')"
            :instructions="[
              { icon: 'gallery.png', label: this.$t('views.seller.my_account.text_1279')},
              { icon: 'document-text.png', label: this.$t('views.seller.my_account.text_1280')},
              { icon: 'gallery-tick.png', label: this.$t('views.seller.my_account.text_1281')},
            ]"
            v-model="file"
            :errorMessage="fileError"
          />
        </b-col>
      </b-row>
		</div>
  </b-form>
</template>

<script>
import _ from 'lodash';
import readFile from '@/utils/readFile';

export default {
  name: 'PersonalDataFormStep',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      file: null,
      fileId: null,
      fileError: '',
      zipCode: '',
      address: {
        zip_code: '',
        street: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
      },
    }
  },
  watch: {
    file() {
      if (this.file) {
        this.fileError = '';
      }
    },
  },
  methods: {
    searchAddress(value) {
      if (!value) {
        return;
      }

      const zipCode = value.replace(/\D/g, '');

      if (zipCode.length < 8) {
        return;
      }

      fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
        .then(response => response.json())
        .then(response => {
          this.address = {
            zip_code: value,
            street: response.logradouro,
            neighborhood: response.bairro,
            city: response.localidade,
            state: response.estado,
            number: this.address.number
          }
        });
    },
    debounce: _.debounce(function () {
      this.searchAddress(this.zipCode);
    }, 500),

    async validateForm() {
      try {
        const fileValidated = this.validateFile();
        const formValidated = await this.$validator.validateAll('personal');
        return (fileValidated && formValidated);
      } catch(error) {
        return false;
      }
    },

    async handleSubmit() {
      this.user.address = Object.assign({}, this.address);
      this.user.documents = [];
      
      const updatedUser = { 
        ...this.user, 
      };

      delete updatedUser.company;

      try {
        const fileDocument = await readFile(this.file);
        fileDocument.subtype = 'PROOF_ADDRESS';

        if (this.fileId) {
          fileDocument.id = this.fileId;
        }

        if (this.file.size) {
          updatedUser.documents = [fileDocument];
        }
        return updatedUser;
      } catch (error) {
        console.log('PersonalDataFormStep::handleSubmit:', error)
        return updatedUser;
      }
    },

    handleFileSelected(file) {
      this.uploadedFile = file;
    },

    handleFileInvalid(message) {
      this.fileErrorMessage = message;
    },
    validateFile() {
      if (!this.file) {
        this.fileError = this.$t('views.seller.my_account.text_1338')
        return false;
      }
      return this.file;
    },
    fillDocument(documents) {
      const proofAddress = this.getDocument(documents, 'PROOF_ADDRESS');

      if (proofAddress) {
        this.fileId = proofAddress.id;

        const ext = proofAddress.path.split('.').pop().toLowerCase();
        const blob = new Blob();
        const file = new File([blob], `comprovante-endereco.${ext}`);

        this.file = file;
      }
    },
    getDocument(documents, subtype) {
      return documents
        .find(document => (document.type === 'USER_DOCUMENT') && (document.subtype === subtype));
    },
  },
  mounted() {
    if (!this.$root.myAccountData) {
      return;
    }

    const { user } = this.$root.myAccountData;

    if (user.address) {
      this.address = {
        street: user.address.street,
        neighborhood: user.address.neighborhood,
        city: user.address.city,
        state: user.address.state,
        number: user.address.number 
      };
      this.zipCode = user.address.zip_code;
    }

    if (user && user.documents && user.documents.length) {
      this.fillDocument(user.documents);
    }

    this.$root.$on('onload-my-account', async ({ user }) => {
      if (user && user.documents && user.documents.length) {
        this.fillDocument(user.documents);
      }
    });
  }
};
</script>

<style scoped></style>
